/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSbpBanksListQueryResponse, GetSbpBanksListQueryParams, GetSbpBanksList400, GetSbpBanksList401, GetSbpBanksList500 } from "../entities/GetSbpBanksList";

function getGetSbpBanksListUrl() {
  const res = { method: 'GET', url: `/api/v1/account/sbp-banks` as const }
  return res
}

/**
 * @description Возвращает справочник банков СБП с поиском по названию и курсорной пагинацией.
 * `id` из ответа передаётся как `bank_id` при выборе банка для вывода.
 * **Требования:**
 * - JWT access-токен (`Authorization: Bearer`) и заголовки `user-id`, `city-id`
 * **Фильтры:**
 * - `name` — подстрока названия банка (`LIKE %name%`)
 * **Пагинация:**
 * - Курсорная (keyset) по `(popularity_score, name, id)` при сортировке
 * `popularity_score DESC, name ASC, id ASC` (популярные сверху; без рейтинга — в конце)
 * - `limit` — количество записей (1–100, по умолчанию 10)
 * - `cursor` — курсор следующей страницы в формате `id_score_name`
 * (пустой score = NULL; например `5_3_Сбербанк`, `12__Альфа-Банк`)
 * - `has_more` и `next_cursor` в ответе
 * `popularity_score` — рейтинг (больше = выше; `null` — обычный банк).
 * `icon_url` — публичный URL иконки в Filestorage; `null`, если иконка не задана.
 * @summary Получить список банков СБП
 * {@link /api/v1/account/sbp-banks}
 */
export async function getSbpBanksList(params?: GetSbpBanksListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSbpBanksListQueryResponse, ResponseErrorConfig<GetSbpBanksList400 | GetSbpBanksList401 | GetSbpBanksList500>, unknown>({ method : "GET", url : getGetSbpBanksListUrl().url.toString(), params, ... requestConfig })
  return res.data
}